import { useQuery, UseQueryResult } from "@tanstack/react-query";
import axios from "axios";
import { useAuthStore } from "../../../console/store/useAuthStore";
import { enum_api_uri } from "../utils/enum";

export interface MemoData {
    delivery_memo_idx: number;
    delivery_memo: string;
}

interface GetMemoResponse {
    data: MemoData[];
}

export const useGetCommonMemo = (): UseQueryResult<GetMemoResponse, Error> => {
    const accessToken = useAuthStore(state => state.accessToken);

    return useQuery<GetMemoResponse, Error>({
        queryKey: ["getCommonMemo"],
        queryFn: async () => {
            const response = await axios.get(`${enum_api_uri.common_get_memo}`, {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
            });
            return response.data;
        },
    });
};
